<template>
  <div :class="keyboardClass"></div>
</template>

<script>
import Keyboard from 'simple-keyboard';
import 'simple-keyboard/build/css/index.css';

export default {
  name: 'SimpleKeyboard',
  props: {
    keyboardClass: {
      default: 'simple-keyboard',
      type: String
    },
    input: {
      type: String
    },
    inputName: {
      type: String
    }
  },
  data: () => ({
    keyboard: null
  }),
  mounted() {
    let icon = require('@/assets/img/svg/icn_delete.svg');
    this.keyboard = new Keyboard({
      onChange: this.onChange,
      onKeyPress: this.onKeyPress,
      inputName: this.inputName,
      layout: {
        default: ['1 2 3', '4 5 6', '7 8 9', '{close} 0 {bksp}', '{clear}']
      },
      display: {
        '{close}': '關閉',
        '{clear}': '清空',
        '{bksp}': `<img src="${icon}" alt="" />`,
        '{enter}': '< enter',
        '@': 'at'
      }
    });
  },
  methods: {
    onChange(input) {
      this.$emit('onChange', input);
    },
    onKeyPress(button) {
      this.$emit('onKeyPress', button);

      /**
       * If you want to handle the shift and caps lock buttons
       */
      if (button === '{shift}' || button === '{lock}') this.handleShift();
      if (button === '{close}') this.handleClose();
      if (button === '{clear}') this.handleClear();
    },
    handleShift() {
      let currentLayout = this.keyboard.options.layoutName;
      let shiftToggle = currentLayout === 'default' ? 'shift' : 'default';

      this.keyboard.setOptions({
        layoutName: shiftToggle
      });
    },
    handleClose() {
      this.$emit('handleClose');
    },

    handleClear() {
      this.$emit('handleClear');
    }
  },
  watch: {
    inputName(inputName) {
      this.keyboard.setOptions({ inputName });
    },
    input(input) {
      this.keyboard.setInput(input);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
